import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  initializeAnalytics() {
    if (typeof gtag === 'undefined') {
    }
  }

  trackFormSubmission(status: 'success' | 'error') {
    // Google Analytics
    if (typeof gtag !== 'undefined') {
      gtag('event', 'form_submission', {
        'event_category': 'Landing Page',
        'event_label': status,
        'value': status === 'success' ? 1 : 0
      });
    }
  }
}